import { useEffect, useRef, useState } from 'react';
import { LinkButton } from '@etg/wings';
import { css, cx } from '@eti/styles';
import { useTranslation } from '@eti/providers';
import { TRACKING_PROPERTIES, useProductSnowplowTracking } from '../../custom-hooks/useProductSnowplowTracking';
import ReadMoreModal from './ProductReadMoreModal';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const linkStyles = css`
  display: inline-block;
  margin-top: 10px;
`;
const ProductReadMore = ({
  content,
  contentAsMarkup,
  isNewCardDesignEnabled,
  modalTitle,
  productName
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const {
    t
  } = useTranslation();
  const rootElement = useRef(null);
  const {
    sendClickEvent,
    addTrackingEventOnLinks
  } = useProductSnowplowTracking(productName);
  const openModal = () => {
    setIsModalOpen(true);
  };
  const closeModal = () => {
    setIsModalOpen(false);
  };
  useEffect(() => {
    if (isModalOpen) {
      sendClickEvent({
        property: TRACKING_PROPERTIES.READ_MORE
      });
      addTrackingEventOnLinks(rootElement);
    }
    // oxlint-disable-next-line react/exhaustive-deps
  }, [isModalOpen]);
  return /*#__PURE__*/_jsxs("div", {
    "data-abtest": "old-readMore-design",
    "data-testid": `${productName}-readmore-container`,
    ref: rootElement,
    children: [/*#__PURE__*/_jsx(LinkButton, {
      className: cx(linkStyles, isNewCardDesignEnabled && 'font-size: 1rem;'),
      "data-testid": `${productName}-readMoreLink`,
      onClick: openModal,
      children: t('Products.ReadMore.Link.Label')
    }), /*#__PURE__*/_jsx(ReadMoreModal, {
      content: content,
      contentAsMarkup: contentAsMarkup,
      modalConfirmLabel: t('Products.ReadMore.Modal.Confirm.Label'),
      onClose: closeModal,
      productName: productName,
      show: isModalOpen,
      title: modalTitle
    })]
  });
};
export default ProductReadMore;
//# sourceMappingURL=ProductReadMoreOld.js.map